import Number from './number/NotePageNumberInitialState'

const { Record } = require('immutable')

export default Record({
    number: Number()
})